import React, { useRef } from "react";
import { useAutoplayRetry } from "../customHooks/useAutoplayRetry";

export function AutoPlaySilentVideo({ video: src, ...props }) {
  const videoRef = useRef(null);
  useAutoplayRetry(videoRef, src);

  return <video {...props} src={src} ref={videoRef} loop autoPlay muted playsInline />;
}
